import type { ApiCallRecord } from 'src/components/star-grid/services/apiCallLog';

export interface ApiCallRow extends ApiCallRecord {
  /** How many identical calls (method, path and body) this page made, so a repeat is visible at a glance. */
  readonly repeats: number;
}

/** Newest first, each call carrying how often its method and path were called. */
export const apiCallRows = (calls: readonly ApiCallRecord[]): ApiCallRow[] => {
  const counts = new Map<string, number>();
  const key = (call: ApiCallRecord): string => `${call.method} ${call.path} ${call.bodyKey}`;
  calls.forEach((call) => counts.set(key(call), (counts.get(key(call)) ?? 0) + 1));
  return [...calls].reverse().map((call) => ({ ...call, repeats: counts.get(key(call)) ?? 1 }));
};

/** A short stable fingerprint of a request body, so identical calls can be counted without keeping bodies. */
export const bodyFingerprint = (body: string): string => {
  let hash = 5381;
  for (let index = 0; index < body.length; index += 1) hash = ((hash << 5) + hash + body.charCodeAt(index)) | 0;
  return `${body.length}:${(hash >>> 0).toString(36)}`;
};
